.ko{font-family:inherit;}